<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #search>
        <ExpansionPanel :isUpDown="false">
          <template #header>
            <div class="searchAreaStyle d-flex align-center mr-5">
              <span class="titleStyle font-weight-bold pl-10">
                {{ $t('common.common_storage') }}
              </span>
            </div>
            <v-checkbox
              v-model="filter.isEnabled"
              :label="$t('common.common_hide-unused-storage-method')"
            />
          </template>
        </ExpansionPanel>

      </template>
      <template #button>
        <NormalButton
          :text="buttonName"
          height="32px"
          width="96px"
          class="text-right"
          @click="dialogInfo.register = true"
        />
        <MasterStorageDialog
          v-model="dialogInfo.register"
          @success="registerSuccess"
        />
      </template>
      <template #list>
        <div class="storageTable">
          <MasterTable
            :headers="headers"
            :masterItems="getFilterStorageList"
            :item-key="itemKey"
          >
            <template #isEnabled="{ item }">
              {{ getStorageStatus(item.isEnabled) }}
            </template>
            <template #name="{ item }">
              <div class="font-weight-bold">{{ item.name || '-' }}</div>
            </template>
            <template #edit="{ item }">
              <v-layout>
                <WhiteButton
                  text="common.common_edit"
                  height="32px"
                  width="48px"
                  class="mx-2"
                  @click="edit(item)"
                />
                <div v-if="item.isEnabled" class="mx-auto">
                  <NormalButton
                    :text="$t('表示')"
                    class="mr-2"
                    btnClass="pa-2"
                    height="32px"
                    @click="editIsEnabledToFalse(item)"
                  />
                </div>
                <div v-else class="mx-auto">
                  <NormalButton
                    :text="$t('非表示')"
                    class="mr-2"
                    btnClass="pa-2"
                    height="32px"
                    color="white"
                    textColor="thinText--text"
                    @click="editIsEnabledToTrue(item)"
                  />
                </div>
              </v-layout>
            </template>
          </MasterTable>
        </div>
      </template>
    </Master>
    <MasterStorageDialog
      v-model="dialogInfo.edit"
      :storageData="storageData"
      :editMode="true"
      @success="editSuccess"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { countryCallingCodeUtil, countryUtil } from '@/util'
import headers from './headers'
import MasterTable from './MasterTable'
import { Master } from '@/components/layouts'
import { ExpansionPanel, NormalButton, WhiteButton } from '@/components/items'
import { MasterStorageDialog } from '@/components/layouts/Dialogs'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    ExpansionPanel,
    Master,
    MasterStorageDialog,
    NormalButton,
    WhiteButton,
    MasterTable
  },
  data: () => {
    return {
      pageTitle: 'product.product_warehouse-management',
      buttonName: 'product.product_storage-register',
      storageData: {},
      headers: headers.headers,
      itemKey: 'storageId',
      dialogInfo: {
        register: false,
        edit: false
      },
      editMode: false,
      filter: {
        isEnabled: true
      }
    }
  },
  async created() {
    this.init()
  },
  computed: {
    ...mapGetters('User', ['authority']),
    getFilterStorageList() {
      let storageList = this.getStorageListFromState()
      // 非表示フラグ
      const isEnabledFlg = this.filter.isEnabled
      if (isEnabledFlg) {
        storageList = storageList.filter((storage) => {
          return storage.isEnabled === 1
        })
      }
      return storageList
    }
  },
  methods: {
    ...mapActions('Storage', ['getStorageListFromApi', 'registerEditStorage']),
    ...mapGetters('Storage', ['getStorageListFromState']),

    async init() {
      await this.getStorageListFromApi()
    },
    setCountryCallingCode(countryId) {
      return countryCallingCodeUtil.getPhoneNumberInfoById(countryId)
    },
    setCountryId(countryId) {
      return countryUtil.getCountryIdInfo(countryId)
    },
    getStorageStatus(isEnabled) {
      const storageStatus = isEnabled
        ? this.$t('common.common_normal')
        : this.$t('common.common_hide')
      return storageStatus
    },
    edit(storage) {
      this.storageData = _cloneDeep(storage)
      this.dialogInfo.edit = true
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    async editIsEnabledToFalse(item) {
      this.editMode = true
      await this.registerEditStorage(this.initDataForEditStorage(item, false))
      item.isEnabled = 0
      this.editMode = false
    },
    async editIsEnabledToTrue(item) {
      this.editMode = true
      await this.registerEditStorage(this.initDataForEditStorage(item, true))
      item.isEnabled = 1
      this.editMode = false
    },
    initDataForEditStorage(item, isEnabled) {
      const formatData = _cloneDeep({ ...item })

      formatData.storageRecipients = formatData.storageRecipients.map((ele) => {
        return {
          storageRecipientId: ele.storageRecipientId,
          name: ele.name,
          note: ele.note,
          postalCode: ele.postalCode,
          address1: ele.address1,
          address2: ele.address2,
          storageRecipientPhone: {
            countryCode: this.setCountryCallingCode(ele.phoneNumberCountryId),
            phoneNumber: ele.phoneNumber
          },
          storageRecipientAddressCountry: this.setCountryId(ele.countryId),
          storageRecipientRegion: countryUtil.getRegionInfo(
            ele.countryId,
            ele.regionId
          )
        }
      })
      // InputFormNewコンポーネントを使用できるようにline1,line2に入力フォームを分けて設定
      const formatStorageRecipientList = formatData.storageRecipients
        ? formatData.storageRecipients.map((ele) => {
            return {
              storageRecipientInfoLine1: {
                storageRecipientName: ele.name,
                storageRecipientPhone: ele.storageRecipientPhone,
                storageRecipientNote: ele.note
              },
              storageRecipientInfoLine2: {
                country: ele.storageRecipientAddressCountry,
                storageRecipientPostalCode: ele.postalCode,
                storageRecipientRegion: ele.storageRecipientRegion,
                storageRecipientAddress1: ele.address1,
                storageRecipientAddress2: ele.address2
              }
            }
          })
        : []
      return {
        mode: 'edit',
        storageId: formatData.storageId,
        storageInfoLine1: {
          storageName: formatData.name,
          isEnabled: isEnabled
        },
        storageRecipientList: formatStorageRecipientList
      }
    }
  }
}
</script>
<style scoped lang="scss">
.search {
  background-color: #fff;
}
.searchAreaStyle {
  height: 70px;
  .titleStyle {
    font-size: 18px;
  }
}
</style>
